import { Check } from '@mui/icons-material'
import { ReactElement, useMemo } from 'react'
import { I18n } from 'src/i18n'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'
import { Status } from './interfaces'

interface Props {
  number: number
  name: string
  status: Status
}

const centered = { className: 'my-auto' }

const Stage = (p: Props): ReactElement => {
  const { number, name, status } = p
  const isActive = useMemo(() => status == Status.ACTIVE, [status])
  const isCompleted = useMemo(() => status == Status.COMPLETED, [status])

  return (
    <Wrapper>
      <StepBox active={isActive} {...centered}>
        {isCompleted ? <StyledCheck {...centered} /> : number}
      </StepBox>
      <div {...centered}>
        <I18n name={name} />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  text-transform: capitalize;
  font-size: 14px;
`

interface StepBoxProps {
  active: boolean
}

const StepBox = styled.div<StepBoxProps>`
  height: 20px;
  width: 20px;
  margin-right: 0.5rem;
  border-radius: 3px;
  background-color: ${(props) =>
    props.active ? defaultTheme.colors.primary : defaultTheme.colors.border};
  color: ${(props) =>
    props.active
      ? defaultTheme.colors.almostBlack
      : defaultTheme.colors.columnBorder};
  text-align: center;
  font-weight: 700;
`

const StyledCheck = styled(Check)`
  font-size: 14px;
  font-weight: 700;
`

export default Stage
